export default "/images/vendor/flag-icon-css/flags/4x3/gb-wls.svg?4abd7bc95cbecde943cceb263f8ef337";